var _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _ellipse, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHobbie2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ae0ed483-2375-4630-8129-5bebfcf074ba",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 658.71676,
    height: 482.74126,
    viewBox: "0 0 658.71676 482.74126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M555.73364,405.49075a30.28061,30.28061,0,0,0-24.18012,12.02346,19.9375,19.9375,0,0,0-27.8185,18.30907h82.33115A30.33247,30.33247,0,0,0,555.73364,405.49075Z",
    transform: "translate(-270.64162 -208.62937)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M669.46656,384.5H309.13411a18.20279,18.20279,0,0,0-18.177,18.177V673.19362a18.20278,18.20278,0,0,0,18.177,18.177H669.46656a18.20278,18.20278,0,0,0,18.177-18.177V402.677A18.20279,18.20279,0,0,0,669.46656,384.5ZM685.5051,673.19362a16.05809,16.05809,0,0,1-16.03854,16.03854H309.13411a16.05809,16.05809,0,0,1-16.03854-16.03854V402.677a16.05809,16.05809,0,0,1,16.03854-16.03854H669.46656A16.05809,16.05809,0,0,1,685.5051,402.677Z",
    transform: "translate(-270.64162 -208.62937)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.7273,
    cy: 289.7442,
    r: 80.7273,
    fill: "#01bf71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M687.64357,613.39127v22.3791H290.9571V613.28431l2.13847-3.07934L418.85921,429.10845a6.196,6.196,0,0,1,10.17914,0l84.34119,121.43311,60.03749-85.6885a6.19679,6.19679,0,0,1,10.15774,0L685.5051,610.33327Z",
    transform: "translate(-270.64162 -208.62937)",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M378.09981,661.432H315.0149a1.06924,1.06924,0,0,1,0-2.13847h63.08491a1.06923,1.06923,0,1,1,0,2.13847Z",
    transform: "translate(-270.64162 -208.62937)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M473.2618,661.432H410.17689a1.06924,1.06924,0,1,1,0-2.13847H473.2618a1.06923,1.06923,0,0,1,0,2.13847Z",
    transform: "translate(-270.64162 -208.62937)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M568.42378,661.432H505.33887a1.06924,1.06924,0,0,1,0-2.13847h63.08491a1.06923,1.06923,0,1,1,0,2.13847Z",
    transform: "translate(-270.64162 -208.62937)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M663.58577,661.432H600.50085a1.06924,1.06924,0,0,1,0-2.13847h63.08492a1.06923,1.06923,0,0,1,0,2.13847Z",
    transform: "translate(-270.64162 -208.62937)",
    fill: "#3f3d56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 771.11348,
    cy: 360.02396,
    rx: 186.04702,
    ry: 115.47746,
    transform: "translate(-312.84579 401.8894) rotate(-42.14571)",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M626.94259,634.38948c-10.27371-21.223-13.91186-45.13592-12.12314-68.54886a164.7354,164.7354,0,0,1,20.13559-66.263c10.82079-19.78486,25.12269-37.49483,41.37971-53.0678,17.25414-16.52812,36.71035-30.5595,57.181-42.82246,21.61642-12.94932,44.33029-23.95387,67.30849-34.25008q4.29545-1.92474,8.60417-3.81958c1.88513-.83.25458-3.5947-1.619-2.76976-23.42777,10.31537-46.65818,21.18613-68.87261,33.94136-21.22249,12.18567-41.5263,26.12564-59.66615,42.59873-16.92179,15.367-32.00276,32.94605-43.69622,52.62852a172.042,172.042,0,0,0-23.16477,65.99464c-2.99577,23.51793-.67967,47.9745,8.23618,70.04087q1.63083,4.03625,3.52694,7.95644c.89923,1.85758,3.66623.2329,2.76977-1.619Z",
    transform: "translate(-270.64162 -208.62937)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M715.42365,411.86714a193.82021,193.82021,0,0,1,3.9125-52.178,197.01375,197.01375,0,0,1,17.5945-49.30733,193.75607,193.75607,0,0,1,15.50017-25.09342c1.21678-1.67076-1.56508-3.27313-2.76977-1.619a196.924,196.924,0,0,0-25.06267,46.63489,200.26218,200.26218,0,0,0-11.88947,51.61944,193.67815,193.67815,0,0,0-.493,29.94343c.12494,2.051,3.33351,2.0652,3.20771,0Z",
    transform: "translate(-270.64162 -208.62937)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M490.90419,456.13876a37.35921,37.35921,0,0,0-29.83262,14.83414A24.59823,24.59823,0,0,0,426.75,493.562h101.5774A37.42318,37.42318,0,0,0,490.90419,456.13876Z",
    transform: "translate(-270.64162 -208.62937)",
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHobbie2);
export default __webpack_public_path__ + "static/media/hobbie2.4bd1f8ffff51e7b40d8ffe79416de6f4.svg";
export { ForwardRef as ReactComponent };